/**
 * Why a payment could not start, for the customer. paymentv3-init answers a refused payment with
 * { error: true, message: <reason> } -- a code such as 'vat_not_eligible' (benefit-eligibility.js
 * in falcon/functions), not a sentence. This maps the code to a translation key; anything unknown
 * gets the generic text, so a new backend reason never shows as a raw code.
 */
const REASON_KEYS = {
  vat_not_eligible: 'payment_refused_benefit_not_allowed',
  collection_not_eligible: 'payment_refused_benefit_not_allowed',
  valuecard_not_sportmoney: 'payment_refused_benefit_not_allowed',
  valuecard_not_single_vat: 'payment_refused_benefit_not_allowed',
  valuecard_vat_not_eligible: 'payment_refused_benefit_not_allowed',
  combination_ticket: 'payment_refused_combination_ticket',
  epassi_ticket_already_owned: 'payment_refused_epassi_ticket_owned',
  no_epassi_configuration_sport: 'payment_refused_benefit_not_in_use',
  no_epassi_configuration_culture: 'payment_refused_benefit_not_in_use',
  no_sportbenefit_configuration: 'payment_refused_benefit_not_in_use',
  empty_cart: 'payment_refused_cart_expired',
  no_order: 'payment_refused_cart_expired',
  eventticket_not_found: 'payment_refused_cart_expired',
  valuecard_not_found: 'payment_refused_cart_expired',
}

export const PAYMENT_REFUSED_GENERIC = 'payment_refused_generic'

export const paymentErrorKey = (reason) => {
  if (!reason || typeof reason !== 'string') return PAYMENT_REFUSED_GENERIC
  if (REASON_KEYS[reason]) return REASON_KEYS[reason]
  if (reason.startsWith('no_epassi_configuration_')) return 'payment_refused_benefit_not_in_use'
  return PAYMENT_REFUSED_GENERIC
}
